import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Heading } from '../Heading';
import Paragraph from '../Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';
import { variables } from '../../assets/styles/variables';

export const ForgotPasswordCardStyle = styled.div`
  max-width: 624px;
  width: 100%;
  box-shadow: 0 3px 8px 0 rgba(112, 120, 135, 0.24);
  border-radius: ${variables.borderRadius.borderRadius};
  border: 1px solid ${themeColors.colorTextSecondary};
  padding: 24px 40px 32px;

  @media only screen and (max-width: 992px) {
    border: none;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
  }
`;

const ForgotPasswordCard = ({ title, subtitle, children }) => (
  <ForgotPasswordCardStyle>
    <Heading fontWeight={700} mb={28}>
      {title}
    </Heading>
    <Paragraph bold isPrimaryColor>
      {subtitle}
    </Paragraph>

    {children}
  </ForgotPasswordCardStyle>
);

ForgotPasswordCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

export default ForgotPasswordCard;
